(function(){
  'use strict';

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function addMobileStyles(){
    if (document.getElementById('erectus-mobile-optimization')) return;
    var style = document.createElement('style');
    style.id = 'erectus-mobile-optimization';
    style.textContent = [
      '@media (max-width:767px){',
      '#lheader .cms-top-header .topbar{min-height:34px!important;padding:0!important;}',
      '#lheader .cms-top-header .topbar .container,#lheader .cms-top-header .topbar .row,#lheader .cms-top-header .announcement-bar{margin:0!important;padding:0!important;min-height:34px!important;width:100%!important;max-width:none!important;}',
      '#lheader .cms-top-header .announcement-bar{display:flex!important;align-items:center!important;justify-content:center!important;flex-wrap:nowrap!important;}',
      '#lheader .cms-top-header .announcement-bar>.erectus-mobile-top-extra{display:none!important;}',
      '#lheader .cms-top-header .announcement-bar>.erectus-mobile-top-message{display:block!important;flex:0 0 100%!important;max-width:100%!important;width:100%!important;padding:0 10px!important;text-align:center!important;}',
      '#lheader .cms-top-header .top_contac{min-height:34px!important;height:auto!important;display:flex!important;align-items:center!important;justify-content:center!important;}',
      '#lheader .cms-top-header .top_contac span{display:block!important;max-width:100%!important;overflow:visible!important;text-overflow:clip!important;white-space:normal!important;font-size:10.5px!important;line-height:14px!important;padding:3px 0!important;text-align:center!important;}',
      '#lheader .header-top .container{padding-left:12px!important;padding-right:12px!important;}',
      '#lheader .header-top .row{position:relative!important;display:flex!important;align-items:center!important;flex-wrap:nowrap!important;min-height:58px!important;margin:0!important;}',
      '#lheader .header-top .row>.header-nav-mobile{display:flex!important;align-items:center!important;justify-content:flex-start!important;flex:0 0 42px!important;width:42px!important;max-width:42px!important;padding:0!important;z-index:3!important;}',
      '#lheader .header-top .row>.header-nav-mobile .mobile-navigation{display:flex!important;align-items:center!important;justify-content:flex-start!important;min-width:38px!important;min-height:44px!important;}',
      '#lheader .header-logo{display:block!important;visibility:visible!important;opacity:1!important;position:absolute!important;left:50%!important;top:50%!important;transform:translate(-50%,-50%)!important;width:auto!important;max-width:42%!important;flex:none!important;padding:0!important;text-align:center!important;z-index:2!important;}',
      '#lheader .header-logo .header-nav-mobile{display:none!important;}',
      '#lheader .header-logo .site-header__logo-image{display:flex!important;visibility:visible!important;opacity:1!important;align-items:center!important;justify-content:center!important;min-width:80px!important;min-height:32px!important;}',
      '#lheader .header-logo img{display:block!important;visibility:visible!important;opacity:1!important;width:auto!important;max-width:120px!important;max-height:38px!important;height:auto!important;margin:0 auto!important;}',
      '#lheader .header-nav{display:none!important;}',
      '#lheader .header-top-meta{margin-left:auto!important;flex:0 0 auto!important;width:auto!important;max-width:44%!important;padding:0!important;z-index:3!important;}',
      '#lheader .header-control{display:flex!important;align-items:center!important;justify-content:flex-end!important;gap:4px!important;margin:0!important;padding:0!important;}',
      '#lheader .header-control>li{display:none!important;margin:0!important;padding:0!important;}',
      '#lheader .header-control>li.header_search,#lheader .header-control>li.box-minicart{display:flex!important;align-items:center!important;}',
      '#lheader .header-control .header-icon{display:flex!important;align-items:center!important;justify-content:center!important;min-width:38px!important;min-height:44px!important;padding:0!important;margin:0!important;}',
      '#lheader .header-control .header_search .text_search{display:none!important;}',
      '#lheader .sticky-icons-fixed{right:12px!important;gap:4px!important;}',
      '#lheader .sticky-icons-fixed a.header-icon:first-child{padding-left:0!important;}',
      '#lheader .sticky-icons-fixed .header-icon,#lheader .sticky-icons-fixed .cart-block{margin:0!important;}',
      '.erectus-cta-wrap{display:none!important;}',
      '.template-index .home_slideshow,.template-index [class*="slideshow"]:not([class*="product"]){display:block!important;}',
      '.template-index #MainContent{margin-top:0!important;}',
      '.template-index .erectus-mobile-desktop-fallback{background-position:center!important;background-size:contain!important;background-repeat:no-repeat!important;}',
      '.template-index [class*="laber_slidershow_"]{margin-bottom:20px!important;}',
      '.template-index .cat-circles{padding:4px 12px!important;margin-bottom:22px!important;}',
      '.template-index .cat-grid{grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:18px 10px!important;}',
      '.template-index .cat-img{width:88px!important;height:88px!important;}',
      '.template-index .cat-item h3{font-size:12px!important;min-height:auto!important;margin-bottom:6px!important;}',
      '.template-index .collection_carousel_product .wrap_title{margin:0 0 14px!important;padding:0 14px!important;}',
      '.template-index .collection_carousel_product .section-title{font-size:24px!important;line-height:1.12!important;letter-spacing:.08em!important;font-weight:700!important;margin:0!important;text-align:center!important;text-transform:uppercase!important;}',
      '.template-index .product-collection__title h4{font-size:13px!important;line-height:1.3!important;min-height:34px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}',
      '.template-index .product-collection__price{font-size:15px!important;}',
      '.template-index .why-us{padding:12px 0 28px!important;margin-bottom:24px!important;}',
      '.template-index .why-us__wrap{padding:0 12px!important;}',
      '.template-index .why-us__title{font-size:24px!important;margin-bottom:14px!important;}',
      '.template-index .why-us__grid{gap:10px!important;}',
      '.template-index .why-card{border-radius:12px!important;}',
      '.template-index .why-card__media{height:100px!important;}',
      '.template-index .why-card__body{padding:10px!important;}',
      '.template-index .why-card__heading{font-size:14px!important;margin-bottom:4px!important;}',
      '.template-index .why-card__text{font-size:12px!important;line-height:1.35!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function optimizeMobileHeader(){
    if (!isMobile()) return;
    document.querySelectorAll('#lheader .cms-top-header .announcement-bar').forEach(function(bar){
      Array.prototype.forEach.call(bar.children, function(child){
        if (child.querySelector('.top_contac')) {
          child.classList.add('erectus-mobile-top-message');
          child.classList.remove('erectus-mobile-top-extra');
        } else {
          child.classList.add('erectus-mobile-top-extra');
          child.classList.remove('erectus-mobile-top-message');
        }
      });
    });
  }

  function fixMobileLogo(){
    if (!isMobile()) return;
    var holder = document.querySelector('#lheader .header-logo .site-header__logo-image');
    if (!holder) return;
    var img = holder.querySelector('img');
    var logoUrl = window.__ERECTUS_MOBILE_LOGO__ || '';
    if (!img && logoUrl) {
      img = document.createElement('img');
      img.alt = 'Erectus';
      holder.appendChild(img);
    }
    if (img && logoUrl) {
      img.src = logoUrl;
      img.removeAttribute('srcset');
      img.style.display = 'block';
      img.style.visibility = 'visible';
      img.style.opacity = '1';
    }
  }

  function fixMobileSlides(root){
    (root || document).querySelectorAll('.wrap_slide').forEach(function(slide){
      var desktop = slide.querySelector('.image_pc');
      var mobile = slide.querySelector('.image_mobile');
      if (!desktop || !mobile) return;

      var mobileBgset = mobile.getAttribute('data-bgset') || '';
      var desktopBgset = desktop.getAttribute('data-bgset') || '';
      var missingMobile = !mobileBgset || /via\.placeholder\.com/i.test(mobileBgset);

      if (missingMobile && desktopBgset) {
        mobile.setAttribute('data-bgset', desktopBgset);
        mobile.classList.add('erectus-mobile-desktop-fallback');
        if (desktop.style.paddingTop) mobile.style.paddingTop = desktop.style.paddingTop;
      }

      if (mobile.classList.contains('erectus-mobile-desktop-fallback')) {
        var desktopBg = window.getComputedStyle(desktop).backgroundImage;
        if (desktopBg && desktopBg !== 'none' && !/placeholder/i.test(desktopBg)) {
          mobile.style.backgroundImage = desktopBg;
        }
      }
    });
  }

  function run(root){
    addMobileStyles();
    optimizeMobileHeader();
    fixMobileLogo();
    fixMobileSlides(root || document);
  }

  run(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  }
  document.addEventListener('lazyloaded', function(e){
    var slide = e.target && e.target.closest ? e.target.closest('.wrap_slide') : null;
    if (slide) run(slide);
  }, true);
  document.addEventListener('shopify:section:load', function(e){ run(e.target || document); });
})();
